module.exports = __webpack_public_path__ + "static/flags/WS-39208d28d05d608f7be37c240b88649a.gif";